import { render, staticRenderFns } from "./FrameHeader.vue?vue&type=template&id=9ad375fa&scoped=true&"
import script from "./FrameHeader.vue?vue&type=script&lang=js&"
export * from "./FrameHeader.vue?vue&type=script&lang=js&"
import style0 from "./FrameHeader.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FrameHeader.vue?vue&type=style&index=1&id=9ad375fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad375fa",
  null
  
)

export default component.exports